import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  passedParams: any = {};

  searchFormMethod() {
    return ['Social Security Number', 'First and Last Name'];
  }

  searchRosterMethod() {
    return [ 'First and Last Name', 'Last 4-digits of SSN', 'Branch'];
  }
}
